import { ISuggestFieldResultItem } from '@vfde-brix/suggest-field';
import { Device } from 'app/container/TradeIn/interfaces/api';

const formatAndSortTradeInPayload = (payload: Device[]): ISuggestFieldResultItem[] => {
    return payload
        .map(device => ({ id: device.id, text: device.name! }))
        .sort((deviceA, deviceB) => deviceA.text!.localeCompare(deviceB.text!));
};

export default formatAndSortTradeInPayload;
